// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__qXhtw","search":"Settings_search__iiQVD","filter":"Settings_filter__1wdYZ"};